import { AbstractModel } from '../../../../backend/server/data-models/abstract-model';

export abstract class AbstractService<T = AbstractModel> {
    public readonly collectionName: string;

    protected constructor(collectionName: string) {
        this.collectionName = collectionName;
    }

    public createSubscription(name?: string, ...args: any[]): Meteor.SubscriptionHandle {
        return Meteor.subscribe(name ? name : this.collectionName, args);
    }
}